import React, { useEffect, useState } from "react";
import "../../../css/MonthAgeSubsc.css";
import { SubscMonthAge, fetchAsyncSubscMonthAge } from "../SubscriberSlice";
import { PieChart, Pie, Tooltip, ResponsiveContainer } from "recharts";
import { useDispatch, useSelector } from "react-redux";

const MonthAgeSubsc = () => {
  const dispatch = useDispatch();
  const SubscMonthAgeData = useSelector(SubscMonthAge);

  const handlePage = (item: number) => {
    setPage(page + item);
  };

  const [page, setPage] = useState(1);

  useEffect(() => {
    // 初回描画時に実行する処理
    dispatch(fetchAsyncSubscMonthAge(page));

    // 定期実行を設定
    const interval = setInterval(() => {
      dispatch(fetchAsyncSubscMonthAge(page));
    }, 60000); // 60秒ごとに実行

    // コンポーネントのクリーンアップ時にインターバルをクリア
    return () => clearInterval(interval);
  }, [dispatch, page]); // 依存配列にdispatchを含める

  return (
    <div className="age_month_container">
      <div className="age_month_title_container">
        <div className="back" onClick={() => handlePage(1)}>
          ←
        </div>
        {SubscMonthAgeData && SubscMonthAgeData.length > 0 && (
          <h2 className="age_month_title">
          年齢別登録者数/{SubscMonthAgeData![0]["month"]}
        </h2>
        )}
        {SubscMonthAgeData && SubscMonthAgeData.length < 1 && (
          <h2 className="age_month_title">
            年齢別登録者数/
          </h2>
        )}
        <div
          className="next"
          onClick={() => {
            handlePage(-1);
          }}>
          →
        </div>
      </div>
      <ResponsiveContainer width="100%" height="75%">
        <PieChart className="Piechart">
          <Pie
            data={SubscMonthAgeData!}
            dataKey="count"
            nameKey="age_group"
            cx="50%"
            cy="50%"
            outerRadius={80}
            fill="#82ca9d"
            label
          />
          <Tooltip />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default MonthAgeSubsc;
